export default {
    data() {
        return {
            publicSettings: {
                currency: null,
                join_form: {
                    make_require_phone_or_cell: false,
                    make_require_primary_email: false,
                },
                surname_config: {
                    udf1: 'Country',
                    udf2: 'State / Prov / Region',
                    udf3: 'County',
                    udf4: 'City',
                    udf5: '',
                    udf6: '',
                    udf7: '',
                    begin_year: 'Begin Year',
                    end_year: 'End Year',
                    alt_spelling: '',
                    notes: '',
                },
            },
        };
    },
    mounted() {
        Promise.all(this.publicSettingsGroups.map(group =>
            this.$api.get('/api/v1/public-settings/' + group)
        )).then(responses => {
            this.publicSettings = Object.assign(
                {},
                this.publicSettings,
                ...responses.map(response => response.data)
            );

            this.$emit('public-settings-fetched');
        });
    },
    methods: {
        getPublicSetting(key) {
            return this.publicSettings[key] ?? null;
        },
    }
}
